<xvi-modal-wrapper
  [title]="title"
  [isShowModal]="showCompanySelector$ | async"
  [buttons]="buttons"
  modalId="modal-company-selector"
>
  <div class="row vertical-align">
    <div class="col-md-12">
      <div class="row grid-tool">
        <div class="col-sm-12">
          <div class="input-group">
            <span class="input-group-addon">
              <i class="glyphicon glyphicon-filter"></i>
            </span>
            <input
              class="form-control"
              id="listQuickFilterInput"
              placeholder="Filter companies"
              type="text"
              (keyup)="onListQuickFilterChanged($event)"
            />
          </div>
        </div>
      </div>
      <xvi-grid
        [XVIGridClass]="'company-selection-grid'"
        [gridOptions]="listGridOptions"
        [columnDefs]="headerNames"
        [rowData]="companies$ | async"
      ></xvi-grid>
    </div>
  </div>
</xvi-modal-wrapper>
